// src/maker/PsycholaborLayout.js
import { useState, useEffect } from 'react';
import { Box, Typography, Tabs, Tab, Button } from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Dashboard as DashboardIcon,
  Add as AddIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import MakerLayout from './MakerLayout';
import PsycholaborDashboard from './PsycholaborDashboard';

const PsycholaborLayout = () => {
  const { t } = useTranslation();
  const { reportId } = useParams();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);

  // Estados de filtros de fecha a nivel del layout
  const [startDate, setStartDate] = useState(
    dayjs().subtract(30, 'day').format('YYYY-MM-DD')
  );
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'));

  // Detectar cuando hay reportId y cambiar al tab "Crear"
  useEffect(() => {
    if (reportId) {
      setTabValue(0);
    }
  }, [reportId]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Función para crear nuevo reporte
  const handleNewReport = () => {
    setTabValue(0);
    navigate('/reports');
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* Header */}
      <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography variant="h4" component="h1" sx={{ mb: 1 }}>
              {t('psycholabor.title')}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t('psycholabor.subTitle')}
            </Typography>
          </Box>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleNewReport}
            size="large"
          >
            {t('reports.reportList.newReport')}
          </Button>
        </Box>
      </Box>

      {/* Tabs Navigation */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="psycholabor tabs">
          <Tab
            icon={<AssignmentIcon />}
            label={t('psycholabor.create')}
            id="psycholabor-tab-0"
            aria-controls="psycholabor-tabpanel-0"
          />
          <Tab
            icon={<DashboardIcon />}
            label={t('psycholabor.dashboard')}
            id="psycholabor-tab-1"
            aria-controls="psycholabor-tabpanel-1"
          />
        </Tabs>
      </Box>

      {/* Tab Panels */}
      <Box sx={{ p: 3 }}>
        {tabValue === 0 && <MakerLayout />}
        {tabValue === 1 && (
          <PsycholaborDashboard 
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={setStartDate}
            onEndDateChange={setEndDate}
            onEditReport={() => setTabValue(0)}
          />
        )}
      </Box>
    </Box>
  );
};

export default PsycholaborLayout;